import { Directive, ElementRef, HostListener, ChangeDetectorRef, inject } from '@angular/core';
import { LayoutService } from '@components/layout/layout.service';

@Directive({
  selector: '[appScrollToFirstInvalid]',
  standalone: false,
})
export class ScrollToFirstInvalidDirective {
  private element = inject(ElementRef);
  layoutService = inject(LayoutService);
  private cdRef = inject(ChangeDetectorRef);

  headerOffsetHeight = this.layoutService.HEADER_OFFSET_HEIGHT;

  @HostListener('submit')
  onSubmit() {
    this.cdRef.detectChanges();

    const errorContent = this.element.nativeElement.querySelector('.spen-mod-error-content');

    if (errorContent) {
      const invalidElement = this.element.nativeElement.querySelector('.ng-invalid:not(div)');
      const errorContentOffsetTop = window.pageYOffset + errorContent.getBoundingClientRect().top;

      // scroll to center of page
      window.scrollTo(0, errorContentOffsetTop - (this.headerOffsetHeight + window.innerHeight) / 2);

      if (invalidElement) {
        invalidElement.focus();
      }
    }
  }
}
